<template>
  <div class="password-reset">
    <h1 v-if="title">{{ title }}</h1>
    <h3 v-if="!statusMessage">{{ blurb }}</h3>
    <div v-if="!statusMessage" class="form-group msg">
      <input v-model="userNameOrEmail" type="email" :placeholder="inputFieldDefault" />
    </div>
    <div v-if="statusMessage" class="form-group">
      {{ statusMessage }}
    </div>
    <div v-if="!statusMessage" class="btn-holder">
      <button @click.prevent="handleSend()">Email me</button>
      <button @click.prevent="redirectToLogin()">Cancel</button>
    </div>
    <div v-if="statusMessage" class="btn-holder">
      <button @click.prevent="redirectToLogin()">Ok</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    inputFieldDefault: {
      type: String,
      default: ''
    },
    blurb: {
      type: String,
      default: ''
    },
    statusMessage: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      userNameOrEmail: ''
    };
  },
  methods: {
    handleSend() {
      if (this.userNameOrEmail) {
        this.$emit('forgot', this.userNameOrEmail);
      }
    },
    redirectToLogin() {
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.password-reset {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  height: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  }
  .form-group {
    label {
      display: block;
    }
    input {
      width: 450px;
      height: 35px;
      text-align: center;
      &:focus {
        outline: none;
      }
    }
    &.msg {
      margin-top: 12px;
    }
  }
  .btn-holder {
    margin-top: auto;
    justify-self: flex-end;
  }

  button {
    //background-color: $green;
    padding: 10px;
    width: 150px;
  }
}
</style>
